import { parsePayloadForQuery } from '@/helpers/utils.js';
import axios from 'axios';
import Vue from 'vue';

export const MODAL_NAME = {
  CREATE: 'create',
  EDIT_DETAILS: 'editDetails',
  GENERAL_DETAILS: 'generalDetails',
  PRESENTATION: 'presentation'
}

const state = {
  items: [],
  modals: {
    create: false,
    editDetails: false,
    generalDetails: false,
    presentation: false
  },
  item: null
};

const getters = {
  getPbiReport: state => state.item,
  getPbiReports: state => state.items,
  isOpen: (state) => (modalName) => state.modals[modalName]
};

const mutations = {
  itemsLoaded(state, payload) {
    state.items = payload;
  },
  itemLoaded(state, payload) {
    state.item = payload;
  },
  open(state, modalName) {
    Vue.set(state.modals, modalName, true);
  },
  close(state, modalName) {
    Vue.set(state.modals, modalName, false);
  },
};

const actions = {
  get(state, payload) {
    let queryParams = '?' + parsePayloadForQuery(payload);
    return axios.get(`/pbi-reports${queryParams}`);
  },
  getUsers(state, payload) {
    let queryParams = '?' + parsePayloadForQuery(payload);
    return axios.get(`/pbi-reports/users${queryParams}`);
  },
  create(state, payload) {
    return axios.post(`/pbi-reports`, payload)
      .then(({ data }) => {
        if (!!data.failures && data.failures.length > 0) {
          console.error('Create pbi report - ERROR - ', data.failures[0].error);
          throw data.failures[0];
        } else {
          return data.successes;
        }
      }).catch(err => { throw err });
  },
  edit(state, payload) {
    return axios.patch(`/pbi-reports`, payload)
      .then(({ data }) => {
        if (!!data.failures && data.failures.length > 0) {
          console.error('Edit pbi report - ERROR - ', data.failures[0].error);
          throw data.failures[0];
        } else {
          return data.successes;
        }
      }).catch(err => { throw err });
  },
  delete(state, payload) {
    return axios.delete(`/pbi-reports?ids=${payload}`)
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};